import { TICKS_PER_BEAT } from '../../shared/tempo';
import type { EnemyDefinition } from '../types';

export interface BeatArmorEffect {
  readonly kind: 'beatArmor';
  readonly cycleBeats: number;
  readonly openBeats: number;
  readonly offBeatMul: number;
}

export const LARSEN: EnemyDefinition = {
  id: 'larsen',
  name: 'Le Larsen',
  description: "Il siffle, et n'encaisse les coups qu'une mesure sur deux.",
  behaviour: 'boss',
  maxHp: 2000,
  speed: 0.75,
  radius: 44,
  damage: 30,
  attackCooldownTicks: 2 * TICKS_PER_BEAT,
  aggroRadius: 320,
  vibesDrop: 50,
  scalingPerPhrase: { hp: 1, speed: 1 },
  special: { kind: 'beatArmor', cycleBeats: 8, openBeats: 4, offBeatMul: 0.25 },
};
